import { library } from "@fortawesome/fontawesome-svg-core";

// import your icons
import { faCopy } from "@fortawesome/free-regular-svg-icons";

import {
  faPinterest,
  faFacebook,
  faTwitter
} from "@fortawesome/free-brands-svg-icons";

import {
  faPlus,
  faTimes,
  faSearch,
  faStar,
  faBell,
  faHeart,
  faAngleDown,
  faUser,
  faHome,
  faUsers,
  faPuzzlePiece,
  faCaretDown,
  faCamera,
  faTrashAlt,
  faPen,
  faClock,
  faDollarSign,
  faCommentAlt,
  faExclamationCircle,
  faSignInAlt,
  faSnowflake,
  faChild,
  faBars,
  faSpinner,
  faAngleLeft,
  faArrowLeft,
  faMinus,
  faUpload,
  faArrowUp,
  faArrowDown,
  faVideo,
  faQuestionCircle
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faCopy,
  faPlus,
  faTimes,
  faSearch,
  faStar,
  faBell,
  faHeart,
  faAngleDown,
  faUser,
  faHome,
  faUsers,
  faCaretDown,
  faPuzzlePiece,
  faCamera,
  faTrashAlt,
  faPen,
  faClock,
  faDollarSign,
  faCommentAlt,
  faPinterest,
  faFacebook,
  faExclamationCircle,
  faSignInAlt,
  faSnowflake,
  faChild,
  faBars,
  faSpinner,
  faTwitter,
  faAngleLeft,
  faArrowLeft,
  faMinus,
  faUpload,
  faArrowDown,
  faArrowUp,
  faVideo,
  faQuestionCircle
);
